import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import AttorneyHubAPIService from "_shared/_api/attorney-hub-api-service";
import { isRejectedWithValue } from "@reduxjs/toolkit";
import type { MiddlewareAPI, Middleware } from "@reduxjs/toolkit";
import Session from "users/__session/session";
import { setSystemNotificationBanner, clearSystemNotificationBanner } from "_shared/_providers/banner/system-notification-banner-provider";
import { AlertType } from "_shared/_views/system-notification-banner/system-notification-banner";

export const api = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: AttorneyHubAPIService.apiBaseUrl,
    prepareHeaders: (headers) => {
      const authToken = Session.loadFromStorage(() => {}).authToken?.value;
      if (authToken) {
        headers.set("Authorization", `Bearer ${authToken}`);
      }
      return headers;
    },
    fetchFn: async (input, init) => {
      if (input instanceof Request) {
        if (input.method.toUpperCase() === "PATCH") {
          input.headers.set("Content-Type", "application/json-patch+json");
        }
      }

      if (init?.method?.toUpperCase() === "PATCH") {
        if (!init.headers)
          init.headers = {
            "Content-Type": "application/json-patch+json",
          };
        if (init.headers instanceof Headers) {
          init.headers.set("Content-Type", "application/json-patch+json");
        }
      }
      return fetch(input, init);
    },
  }),
  tagTypes: [
    "EntityMember",
    "Individual",
    "NetworkedGroup",
    "NetworkInvitation",
    "Proposal",
    "UserCoworker",
    "UserInformation",
    "UserNetworkConnection",
  ],
  endpoints: () => ({}),
});

function getErrorStatus(payload: unknown): number {
  if (typeof payload !== "object" || payload === null) return 0;

  const status = (payload as { status?: unknown }).status;
  return typeof status === "number" ? status : 0;
}

export const rtkQueryErrorLogger: Middleware = (api: MiddlewareAPI) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    console.error("We got a rejected action!", api, action);
    const errorStatus = getErrorStatus(action.payload);
    if (!errorStatus) {
      setSystemNotificationBanner(
        AlertType.Error,
        "AttorneyHub is currently unavailable. Please check your internet connection and try again later."
      );
    }
  } else {
    clearSystemNotificationBanner();
  }
  return next(action);
};
